import { createSlice, 
         PayloadAction 
       }                            from "@reduxjs/toolkit";
import { RootState }                from "store/Store";
import { APIData }                  from "types/cms/frontendTypes";

export interface HomeProfileReducerState {
  metadata        : APIData<'api::home-profile-attribute.home-profile-attribute'>[] | undefined
  homeProfile     : APIData<'api::utility-home-profile.utility-home-profile'> | undefined
  unsavedRows     : Record<string, any>;
  hasUnsavedRows  : boolean;
}

const defaultState : HomeProfileReducerState = {
  metadata        : undefined,
  homeProfile     : undefined,
  unsavedRows     : {},
  hasUnsavedRows  : false
}

export const homeProfileSlice = createSlice({
  name : 'homeProfile',
  initialState : defaultState,
  reducers : {
    setHomeProfileMetadata : (state : HomeProfileReducerState, 
                              action : PayloadAction<APIData<'api::home-profile-attribute.home-profile-attribute'>[]>) => {
      state.metadata = action.payload
    },

    setHomeProfile : (state : HomeProfileReducerState, 
                      action : PayloadAction<APIData<'api::utility-home-profile.utility-home-profile'>>) => {
      state.homeProfile = action.payload
    },

    updateHomeProfile : (state : HomeProfileReducerState, 
                        action : PayloadAction<APIData<'api::utility-home-profile.utility-home-profile'>>) => {
      state.homeProfile = action.payload
    },

    setUnsavedRowAction: (state: HomeProfileReducerState, action: PayloadAction<{
      id: string;
      diff: any;
    }>) => {
      state.unsavedRows[action.payload.id] = action.payload.diff;
      state.hasUnsavedRows = true;
    },

    discardUnsavedRowAction: (state: HomeProfileReducerState, action: PayloadAction<string>) => {
      delete state.unsavedRows[action.payload];
      if (Object.keys(state.unsavedRows).length === 0) {
        state.hasUnsavedRows = false;
      }
    },

    discardAllUnsavedRowsAction: (state: HomeProfileReducerState) => {
      state.unsavedRows = {};
      state.hasUnsavedRows = false;
    }
  } as any
}) as any

export const {
  setHomeProfileMetadata,
  setHomeProfile,
  updateHomeProfile,
  setUnsavedRowAction,
  discardUnsavedRowAction,
  discardAllUnsavedRowsAction
} = homeProfileSlice.actions

export const selectHomeProfileMetadata = (state : RootState) => (state.homeProfile as HomeProfileReducerState).metadata
export const selectHomeProfile = (state : RootState) => (state.homeProfile as HomeProfileReducerState).homeProfile
export const selectUnsavedRows = (state: RootState) => (state.homeProfile as HomeProfileReducerState).unsavedRows;
export const selectHasUnsavedRows = (state: RootState) => (state.homeProfile as HomeProfileReducerState).hasUnsavedRows;